<template>
  <div>
    <!-- 如果有子菜单且子菜单不全是隐藏的，渲染为 el-submenu -->
    <el-submenu 
      v-if="hasVisibleChildren" 
      :index="fullPath" 
      :key="item.name"
    >
      <template slot="title">
        <img 
          v-if="item.meta.icon" 
          :src="item.meta.icon" 
          alt="icon" 
          class="app_nav_icon" 
        />
        <span class="submenu-item-title" :title="$t(item.meta.title)">
          {{ $t(item.meta.title) }}
        </span>
      </template>
      
      <!-- 递归渲染子菜单项 -->
      <MenuItemRecursive
        v-for="child in visibleChildren"
        :key="child.name"
        :item="child"
        :base-path="fullPath"
      />
    </el-submenu>

    <!-- 如果没有子菜单或子菜单都隐藏了，渲染为 el-menu-item -->
    <el-menu-item 
      v-else 
      :index="fullPath" 
      :key="item.name"
    >
      <img 
        v-if="item.meta && item.meta.icon" 
        :src="item.meta.icon" 
        alt="icon" 
        class="app_nav_icon" 
      />
      <div slot="title">
        <span 
          class="submenu-item-title" 
          :title="item.meta ? $t(item.meta.title) : ''"
        >
          {{ item.meta ? $t(item.meta.title) : '' }}
        </span>
      </div>
    </el-menu-item>
  </div>
</template>

<script>
export default {
  name: 'MenuItemRecursive',
  props: {
    item: {
      type: Object,
      required: true
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  computed: {
    // 计算完整路径
    fullPath() {
      if (this.basePath) {
        // 如果 item.path 以 / 开头，直接使用，否则拼接
        return this.item.path.startsWith('/') 
          ? this.item.path 
          : `${this.basePath}/${this.item.path}`;
      }
      return this.item.path;
    },
    
    // 获取可见的子菜单项
    visibleChildren() {
      if (!this.item.children || !this.item.children.length) {
        return [];
      }
      return this.item.children.filter(child => !child.meta || !child.meta.hidden);
    },
    
    // 判断是否有可见的子菜单
    hasVisibleChildren() {
      return this.visibleChildren.length > 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.app_nav_icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  vertical-align: middle;
}

.submenu-item-title {
  display: inline-block;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
</style>
